export default {
  companyTestsMetadata: {},
};
